import React, { useEffect, useState, useRef } from "react";
import Content from "../layout/Content";
import Image from "next/image";
import ScoreCard from "../ScoreCard/ScoreCard";
import Link from "next/link";
import { FaCheckCircle } from "react-icons/fa";
import LiveGameSample from "../../assets/images/liveGameSample.png";
import MikeMcClure from "../../assets/images/profiles/MikeMcClure.png";
import MonicaSenderos from "../../assets/images/profiles/MonicaSenderos.png";
import TimWilliams from "../../assets/images/profiles/TimWilliams.png";
import { CustomCarousel } from "../CustomCarousel";
import { quoteSvg } from "../../pages";
import Accordion from "../accordion/Accordion";
import { accordionData } from "../../pages/welcome";
import UpdatePlan from "../update-plan/UpdatePlan";
import ScoreCardFuturesGames from "../ScoreCardFuturesGames/ScoreCardFuturesGames";
import Testimony from "../home/Testimony";
import { SIGNUPS_CLOSED_MESSAGE } from "../../constants/main";

export default function FreeScoreCenter({
  ncaaLiveGame = "",
  nbaLiveGame = "",
  store,
  isStandardPlan,
  isPremiumPlan,
  user,
  leagueFromUrl,
}) {
  const [noLive, setNoLive] = useState(false);
  const videoRef = useRef(null);
  useEffect(() => {
    if (!ncaaLiveGame && !nbaLiveGame) {
      setTimeout(() => {
        setNoLive(true);
      }, 1500);
    } else {
      setNoLive(false);
    }
  }, [ncaaLiveGame, nbaLiveGame]);
  // useEffect(() => {
  //   setTimeout(() => {
  //     if (videoRef.current) {
  //       videoRef.current.play();
  //       // videoRef.current.muted = false;
  //     }
  //   }, 2000);
  // }, [videoRef]);

  return (
    <Content className="non-logged-in-user pt-3" id="ContentBox" style={{ minHeight: "100vh" }}>
      <Content.HeaderPrimary className="Scoreside header-primary-box ">
        <>
          <div className="scoreHeader" style={{ flex: 1 }}>
            <div className="headerTitle">ScoreCenter </div>
            <h5>Live ShotQuality scoring to power your live bets.</h5>
          </div>
        </>
      </Content.HeaderPrimary>
      <Content.Body className="Scoreside">
        <div className="row p-2 pt-3" style={{ boxShadow: "rgba(0, 0, 0, 0.09) 0px 3px 12px" }}>
          <div className="col-md-6 col-sm-12 pb-4 mb-4">
            <div className="pt-2 pb-4">
              {/* <script async src="https://platform.twitter.com/widgets.js"></script>
              <blockquote className="twitter-tweet" data-media-max-width="560">
                <p lang="en" dir="ltr">
                  First time in 12 days without attending a D1 college basketball game. So here's a runthrough of a
                  couple applications for{" "}
                  <a href="https://twitter.com/ShotQualityBets?ref_src=twsrc%5Etfw">@ShotQualityBets</a> and their
                  incredible resources!
                  <br />
                  <br />
                  Here is the link to the live show tonight using the tools!{" "}
                  <a href="https://t.co/H20RxLmyya">https://t.co/H20RxLmyya</a>
                  <br />
                  <br />
                  CINDERELLA24 for 15% off <a href="https://t.co/oc9EA0vgcR">pic.twitter.com/oc9EA0vgcR</a>
                </p>
                &mdash; Coleman Crawley (@SharpshotSelect){" "}
                <a href="https://twitter.com/SharpshotSelect/status/1749933746050978069?ref_src=twsrc%5Etfw">
                  January 23, 2024
                </a>
              </blockquote> */}
              <video
                ref={videoRef}
                width="100%"
                height="auto"
                style={{
                  maxWidth: "25rem",
                  marginBottom: "1rem",
                  display: "block",
                }}
                controls
                autoPlay
                muted
              >
                <source
                  src={"https://shotquality-use1-bets-public.s3.us-east-1.amazonaws.com/justin+perri+bets+promo.mp4"}
                  type="video/mp4"
                />
                <source
                  src={"https://shotquality-use1-bets-public.s3.us-east-1.amazonaws.com/justin+perri+bets+promo.mp4".replace(
                    ".mp4",
                    ".ogg"
                  )}
                  type="video/ogg"
                />
                Your browser does not support the video tag.
              </video>
            </div>
            <div>
              <h5>
                <FaCheckCircle /> <span>Analyze teams and players against expected performance</span>
              </h5>
              <h5>
                <FaCheckCircle /> <span>Get insights into historical performance based on live situations</span>
              </h5>
              <h5>
                <FaCheckCircle /> <span>Access to select marquis games</span>
              </h5>
            </div>
          </div>
          {leagueFromUrl === "ncaa" ? (
            <div className="col-md-6 col-sm-12">
              <h4 className="mt-5 mb-5">
                No Free NCAA games are available! <br />
              </h4>
              {user ? (
                <p className="mb-5">{SIGNUPS_CLOSED_MESSAGE}</p>
              ) : (
                <a className="btn btn-orange mb-5" href={`/login`}>
                  Sign In to Access ScoreCenter &gt;
                </a>
              )}
            </div>
          ) : (
            <div className="col-md-6 col-sm-12">
              <h2>Today's Live Games:</h2>
              {ncaaLiveGame && (
                <>
                  <div className="gameCardList">
                    {ncaaLiveGame.status === "live" ? (
                      <ScoreCard
                        isToday={true}
                        isLive={true}
                        key={ncaaLiveGame.game_id}
                        data={ncaaLiveGame}
                        store={store}
                        isStandardPlan={isStandardPlan}
                        isPremiumPlan={isPremiumPlan}
                        index={0}
                        user={user}
                        leagueFromUrl={"college_mens"}
                      />
                    ) : (
                      <ScoreCardFuturesGames
                        key={ncaaLiveGame.id}
                        card={ncaaLiveGame}
                        isStandardPlan={isStandardPlan}
                        isPremiumPlan={isPremiumPlan}
                        user={user}
                        fromFreeLive={true}
                        leagueType={"ncaa"}
                      />
                    )}
                  </div>
                  {!user && (
                    <a className="btn btn-orange" href={`/login`}>
                      Sign In to Access ScoreCenter &gt;
                    </a>
                  )}
                </>
              )}
              {nbaLiveGame && (
                <>
                  <div className="gameCardList">
                    {nbaLiveGame.status === "live" ? (
                      <ScoreCard
                        isToday={true}
                        isLive={nbaLiveGame.status === "live"}
                        key={nbaLiveGame.game_id}
                        data={nbaLiveGame}
                        store={store}
                        isStandardPlan={isStandardPlan}
                        isPremiumPlan={isPremiumPlan}
                        index={0}
                        user={user}
                        leagueFromUrl={"nba"}
                      />
                    ) : (
                      <ScoreCardFuturesGames
                        key={nbaLiveGame.id}
                        card={nbaLiveGame}
                        isStandardPlan={isStandardPlan}
                        isPremiumPlan={isPremiumPlan}
                        user={user}
                        fromFreeLive={true}
                        leagueType={"nba"}
                      />
                    )}
                  </div>
                  {!user && (
                    <a className="btn btn-orange" href={`/login`}>
                      Sign In to Access ScoreCenter &gt;
                    </a>
                  )}
                </>
              )}
              {!ncaaLiveGame && !nbaLiveGame && noLive && (
                <>
                  <h4 className="mt-5 mb-5">
                    There are no live games today. <br />
                  </h4>
                  {user ? (
                    <p className="mb-5">{SIGNUPS_CLOSED_MESSAGE}</p>
                  ) : (
                    <a className="btn btn-orange mb-5" href={`/login`}>
                      Sign In to Access ScoreCenter &gt;
                    </a>
                  )}
                </>
              )}
            </div>
          )}
        </div>
      </Content.Body>
      <section className="testimonials-new " style={{ background: "white", color: "black" }}>
        <Testimony />
      </section>
      <section className="update-plan">
        <UpdatePlan />
      </section>
      <section className="accordion-container frequently-asked">
        <div className="Scoreside">
          <div className="row mb-5 pt-5" itemScope itemType="https://schema.org/FAQPage">
            <div className="box col-sm-12 col-md-5 titles-container mb-3">
              <h2 style={{ maxWidth: "25rem", margin: "auto" }}>Frequently Asked Questions</h2>
            </div>
            <div className="col-sm-12 col-md-7">
              {accordionData.map(({ name, acceptedAnswer, id }) => {
                return (
                  <div key={id} className="col-md-12 faq-item">
                    <Accordion title={name} content={acceptedAnswer.text} id={id} key={name} />
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>
    </Content>
  );
}
